import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { selectToken } from "../../auth/auth.selector";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight, convertTime } from "../../common-data/Converts";
import OnlyDateFilter from "../common/OnlyDateFilter";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { assignedMembers } from "../../../data/ApiEndpoints";

const AssignedMembers = ({ clickValues, sendableStatsQPs }) => {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const { assignToId } = clickValues || {};

  const queryParams = new URLSearchParams(sendableStatsQPs);
  const startDateParam = queryParams.get("start_date");
  const endDateParam = queryParams.get("end_date");
  const formattedStartDate = startDateParam
    ? moment(startDateParam).format("DD-MM-YYYY")
    : null;
  const formattedEndDate = endDateParam
    ? moment(endDateParam).format("DD-MM-YYYY")
    : null;

  const iniAllFilters = {
    selectedStartDate: formattedStartDate
      ? formattedStartDate
      : moment().tz("Asia/Kolkata").format("DD-MM-YYYY"),
    selectedEndDate: formattedEndDate
      ? formattedEndDate
      : moment().tz("Asia/Kolkata").format("DD-MM-YYYY"),
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const initialFilters = {
    assigned_to: "",
    start_date: "",
    end_date: "",
  };
  const [filters, setFilters] = useState(initialFilters);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const [isPage, setIsPage] = useState(0);

  const onClickReset = () => {
    setFilters(initialFilters);
    setAllFilters({
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: 10,
      assigned_to: assignToId,
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
    }));
  }, [allFilters, sendableStatsQPs, assignToId, isPage]);

  useEffect(() => {
    if (filters.assigned_to) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: assignedMembers,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (error) {
      console.error(error);
      setTbDatas(iniTbDatas);
    } else if (data?.status) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data?.data?.length > 0 ? data.data : [],
        pagination: data?.pagination?.length > 0 ? data.pagination : [],
      }));
    } else {
      console.error("Something Went Wrong!");
      setTbDatas(iniTbDatas);
    }
  }, [data, error]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "assigned_to_name",
      text: "Assigned To",
      formatter: (cell, row) => {
        const shiftTimings = row?.assigned_to_shift?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm").format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <div
            className="emeberDetailsRowContainer"
            style={{
              flexDirection: "column",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <span className="tb-data hoverBlue minWidth150">
              {row?.assigned_to_name || "NA"}
              <br />
              {row?.assigned_to_mobile || ""}
              <br />
              {row?.assigned_to_name && shiftTiming ? shiftTiming : ""}
            </span>
          </div>
        );
      },
    },
    // {
    //   dataField: "assigned_to_name",
    //   text: "Assign To",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.assigned_to_name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "user_name",
      text: "Member",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            {row?.user_mobile || ""}
          </span>
        );
      },
    },
    {
      dataField: "profession",
      text: "Member Profession",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.profession || "NA"}</span>;
      },
    },
    {
      dataField: "last_checkin_days_ago",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.last_checkin_days_ago?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin Date / Time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />
            {row?.checkin_time ? convertTime(row.checkin_time) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <OnlyDateFilter
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        MCLDate={true}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default AssignedMembers;
